module.exports = __webpack_public_path__ + "img/userDefault.f819b7ae.svg";